import i18next from 'i18next';
import common from '../../common';
import ScenarioCard from './ScenarioCard';

export default class ScenarioCarousel extends PIXI.Container {
	constructor() {
		super();

		this._cards = [];
		this._index = 0;
		this._animating = false;
		this._leftButton = null;
		this._rightButton = null;

		this.signals = {
			selected: new P3.utils.MiniSignal(),
		};

		this._data = [
			{ disastername: 'gui.general.disasters.tsunami', name: 'gui.selectscenario.scenario1.title', description: 'gui.selectscenario.scenario1.terrain', image: 'select_tsunami', icon: 'icon_tsunami' },
			{ disastername: 'gui.general.disasters.earthquake', name: 'gui.selectscenario.scenario2.title', description: 'gui.selectscenario.scenario2.terrain', image: 'select_earthquake', icon: 'icon_earthquake' },
			{ disastername: 'gui.general.disasters.flood', name: 'gui.selectscenario.scenario3.title', description: 'gui.selectscenario.scenario3.terrain', image: 'select_flood', icon: 'icon_flood' },
			{ disastername: 'gui.general.disasters.wildfire', name: 'gui.selectscenario.scenario4.title', description: 'gui.selectscenario.scenario4.terrain', image: 'select_wildfire', icon: 'icon_wildfire' },
			{ disastername: 'gui.general.disasters.hurricane', name: 'gui.selectscenario.scenario5.title', description: 'gui.selectscenario.scenario5.terrain', image: 'select_hurricane', icon: 'icon_hurricane' },
		];

		this.init();
	}

	init() {
		this.sortableChildren = true;

		let largest = 0;

		for (let i = 0; i < this._data.length; i++) {
			const card = new ScenarioCard(this._data[i], i);

			card.position.set(i * 450 * 0.45, 0);
			this.addChildAt(card, 0);

			card.interactive = true;
			card.buttonMode = true;
			card.on('pointerup', () => {
				if (this._index !== i) {
					this._index = i;
					this.sortCards();
				}
			});

			card.signals.play.add((index) => {
				this.signals.selected.dispatch(index);
			});

			this._cards.push(card);

			largest = Math.max(largest, card.height);
		}

		for (let i = 0; i < this._cards.length; i++) {
			this._cards[i].resize(largest);
		}

		const states = new P3.ButtonStates();

		states.normal = P3.assets.texture('btn_chevron_r_out');

		this._rightButton = common.buttonFactory.createButton(states);
		this._rightButton.position.set(460, 0);
		this._rightButton.signals.click.add(this.scrollRight, this);
		this._rightButton.accessibleTitle = i18next.t('accessibility.button.next');
		this._rightButton.tabIndex = 2;
		this.addChild(this._rightButton);

		this._leftButton = common.buttonFactory.createButton(states);
		this._leftButton.clickSoundName = 'sfx_genericclick';
		this._leftButton.position.set(-460, 0);
		this._leftButton.signals.click.add(this.scrollLeft, this);
		this._leftButton.scale.x = -1;
		this._leftButton.visible = false;
		this.addChild(this._leftButton);

		this._leftButton.accessibleTitle = i18next.t('accessibility.button.previous');
		this._leftButton.tabIndex = 2;

		this.sortCards();
	}

	sortCards() {
		this._animating = true;

		for (let i = 0; i < this._cards.length; i++) {
			this._cards[i].zIndex = i === this._index ? 1 : 0; // requires sortableChildren = true

			new TWEEN.Tween(this._cards[i].position, this.tweens)
				.to({
					x: (i - this._index) * 450 * 0.45,
					y: 0,
				}, 150)
				.easing(TWEEN.Easing.Quadratic.Out)
				.start();

			new TWEEN.Tween(this._cards[i].scale, this.tweens)
				.to({
					x: i === this._index ? 1 : 0.9,
					y: i === this._index ? 1 : 0.9,
				}, 150)
				.easing(TWEEN.Easing.Quadratic.Out)
				.start();

			const visible = i + 2 > this._index && i - 2 < this._index;

			this._cards[i].interactive = visible;

			new TWEEN.Tween(this._cards[i], this.tweens)
				.to({
					alpha: visible ? i === this._index ? 1 : 0.8 : 0,
				}, 150)
				.easing(TWEEN.Easing.Quadratic.Out)
				.onComplete(() => {
					this._animating = false;
				})
				.start();
		}
	}

	scrollLeft() {
		if (this._index > 0 && !this._animating) {
			this._index--;
			this.sortCards();

			this._rightButton.visible = true;
			if (this._index === 0) {
				this._leftButton.visible = false;
			}
		}
	}

	scrollRight() {
		if (this._index < this._cards.length - 1 && !this._animating) {
			this._index++;
			this.sortCards();

			this._leftButton.visible = true;
			if (this._index === this._cards.length - 1) {
				this._rightButton.visible = false;
			}
		}
	}

	destroy() {
		super.destroy();
	}

	update() {
		super.update();
	}

	get index() {
		return this._index;
	}

	get selected() {
		return this._data[this._index];
	}
}
